import ConfirmationModal from 'components/V2/ConfirmationModal';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  triggerBlockedFailedPaymentModal,
  triggerWaitUntilFailedPaymentProcessModal,
} from 'redux/ducks/Modals';

const FailedPaymentModals = ({
  blockedForFailedPayment,
  waitUntilPaymentProcess,
  toggleBlockedForFailedPayments,
  toggleWaitUntilFailedPaymentProcess,
  ...props
}) => {
  const onChangePaymentMethod = () => props.history.push('/edit-payment');

  return (
    <>
      <ConfirmationModal
        isOpen={blockedForFailedPayment}
        toggle={toggleBlockedForFailedPayments}
        title="Payment Issue"
        htmlBody
        body={
          <>
            <p>
              One or more payments on your account have failed. Please update your payment method or
              contact your bank/credit card company to resolve the issue.
            </p>
            <p>
              Need help? Reach out to <a href="mailto:support@go4.io">support@go4.io</a>.
            </p>
          </>
        }
        onSave={onChangePaymentMethod}
        cancelText="Close"
        confirmText="Update Payment Method"
      />
      <ConfirmationModal
        isOpen={waitUntilPaymentProcess}
        toggle={toggleWaitUntilFailedPaymentProcess}
        title="Payment Issue"
        body={`Your balance is being processed and may take up to 24 hours to clear. Once complete, you’ll be able to post jobs and accept applications again.`}
        onSave={() => {}}
        confirmText="Close"
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  blockedForFailedPayment: state.modals.blockedForFailedPayment,
  waitUntilPaymentProcess: state.modals.waitUntilFailedPaymentProcess,
});

const mapDispatchToProps = (dispatch) => ({
  toggleBlockedForFailedPayments: () => dispatch(triggerBlockedFailedPaymentModal()),
  toggleWaitUntilFailedPaymentProcess: () => dispatch(triggerWaitUntilFailedPaymentProcessModal()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FailedPaymentModals));
